import axios from 'axios';

const url = process.env.VUE_APP_API_BASE_URL;

function get(params) {
  const options = {
    params: params,
  };

  return axios
    .get(`${url}/info/IF_release_years`, options)
    .then((res) => {
      if (res.hasOwnProperty('data') && res.data.error) {
        let errorInfo = '';
        for (const [key, value] of Object.entries(res.data)) {
          errorInfo += `<br> ${key}: ${value} <br>`;
        }
        errorInfo += `<br> API LINK: ${url}/info/IF_release_years <br>`;
        throw new Error(errorInfo);
      }
      return res;
    })
    .catch((err) => {
      throw new Error(err.stack);
    });
}

export default {
  get,
};
